import React from 'react';
import HeroBanner from './homeComponents/hero-banner';
import HeroFeature from './homeComponents/hero-feature';
import HeroTypes from './homeComponents/hero-types';
import usePageTitle from '../usePageTitle';

export default function Home() {
    usePageTitle({
        title: 'TaxObey | Home',
        description: 'TaxObey helps individuals and businesses with tax compliance, advisory support, and accounting services in Sri Lanka.',
        path: '/',
    });

    return (
        <div className="home">
            <HeroBanner />
            <HeroFeature />
            <HeroTypes />
        </div>
    );
}